import {
  DATA_CLIENT_STATUS,
  DATA_RPQ_STATUS,
  DATA_ORDER_STATUS,
  DATA_DN_STATUS,
  DATA_DN_PAYMENT_STATUS,
  DATA_DN_AGING_STATUS,
  DATA_PRODUCT_STATUS,
  DATA_USER_DISPOSAL_STATUS,
  DATA_ORDER_SERVICE_STATUS,
} from "./options";
import { INVESTMENT_TRANSACTION_STATUS_OPTIONS } from "../helpers/investmentTransactionStatusLabels";

const RENEWAL_STATUS_OPTIONS = [
  { value: "", label: "(None)" },
  { value: "PENDING", label: "Pending" },
  { value: "WAIT", label: "Wait to confirm" },
  { value: "CONFIRM", label: "Confirmed" },
  { value: "RENEWED", label: "Renewed" },
  { value: "TERMINATED", label: "Terminated" },
];

const POLICY_STATUS_OPTIONS = [
  { value: "NONE", label: "None" },
  { value: "POLICY_RECEIVED", label: "Policy Received" },
  { value: "POLICY_DISPATCHED", label: "Policy Dispatched" },
];

const USER_STATUS_OPTIONS = [
  { value: "DFT", label: "Draft" },
  { value: "PENDING", label: "Pending" },
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
  { value: "TERMINATED", label: "Terminated" },
];

const QUIZ_STATUS_OPTIONS = [
  { value: "DFT", label: "Draft" },
  { value: "DRAFT", label: "Draft (legacy)" },
  { value: "ACTIVE", label: "Active" },
  { value: "CLOSED", label: "Closed" },
];

export const MCA_ENTITIES = [
  {
    value: "client",
    label: "Client",
    watchFields: [
      "age",
      "annualIncome",
      "accountCloseDate",
      "inactiveAt",
      "birthYear",
      "disposalStatus",
      "disposedAt",
      "birthday",
      "bussinessNature",
      "cname",
      "code",
      "consultants",
      "contactPerson",
      "contacts",
      "currentAssets",
      "currentAssetsCurrency",
      "educationLevel",
      "email",
      "emails",
      "fax",
      "gender",
      "givenName",
      "id",
      "idDocExpiryDate",
      "identity.hkbr",
      "identity.hkid",
      "identity.passport",
      "identity.staffNo",
      "identityExpired",
      "idIssueCountry",
      "idType",
      "otherIds",
      "industry",
      "isTransfer",
      "language",
      "mailType",
      "marketingPreference",
      "maritalStatus",
      "name",
      "nationality",
      "occupation",
      "parentCompany",
      "pep.isPep",
      "pep.remark",
      "phone",
      "phone2",
      "phones",
      "piAnnualConfirmationDate",
      "piEffectiveDate",
      "piExpirationReminderDate",
      "piTerminationDate",
      "placeOfBirth",
      "professionalInvestor",
      "knowledgeOfDerivatives",
      "potentiallyIncreasedRisk",
      "remark",
      "clientRemarks",
      "addresses",
      "residentialCountry",
      "salaryPayRatio",
      "salutation",
      "status",
      "incomeSources",
      "aml",
      "rpq",
      "rpqStatus",
      "surname",
      "type",
      "vulnerable",
      "yearlySalary",
      "lineOfBusiness",
      "clientClass",
      "requiresCdd",
      "eddRequired",
      "eddFlagged",
      "complianceReviewRequired",
      "dueDiligence.country",
      "majorInvestmentPortfolio",
      "specimenSignatureChanged",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: DATA_CLIENT_STATUS },
      {
        field: "disposalStatus",
        label: "Disposal Status",
        options: [
          { value: "NONE", label: "None" },
          { value: "ELIGIBLE", label: "Eligible" },
          { value: "DISPOSED", label: "Disposed" },
        ],
      },
      { field: "rpqStatus", label: "RPQ Status", options: DATA_RPQ_STATUS },
    ],
  },
  {
    value: "order",
    label: "Order",
    watchFields: [
      "aipAt",
      "applicationMethod",
      "basicOrder",
      "bidConsultants",
      "client",
      "clientPotentiallyIncreasedRisk",
      "commissionSetting",
      "consultants",
      "createdBy",
      "dateBackOption",
      "debitNote",
      "forceUncertainPayment",
      "fnaSignDate",
      "handlerBy",
      "handlerBy2",
      "insuredAge",
      "isCertainPayment",
      "isGI",
      "isRider",
      "isSplit",
      "lapsedSurrenderDate",
      "mainlandChineseVisitor",
      "mpfAccountType",
      "payment.actualYearRate",
      "payment.creditCardLast4",
      "payment.currency",
      "payment.initialPayment",
      "payment.initialPaymentCurrency",
      "payment.levy",
      "payment.maturityDate",
      "payment.payBy",
      "payment.payCount",
      "payment.payMode",
      "payment.payStatus",
      "payment.paymentTerm",
      "payment.paymentTermUntilAge",
      "payment.payUpDate",
      "payment.policyTerm",
      "payment.preliminaryDate",
      "payment.prePayment",
      "payment.prePaymentCurrency",
      "payment.premium",
      "payment.renewalPayBy",
      "payment.sumInsured",
      "payment.yearCommission",
      "payment.yearConsultant1Commission",
      "payment.yearConsultant2Commission",
      "payment.yearConsultantCommission",
      "payment.yearPremium",
      "payment.yearRate",
      "policyAckSignDate",
      "policyCommenceDate",
      "policyCoolingOffDate",
      "policyDeliverDate",
      "policyDeliverMethod",
      "policyDeliverRemark",
      "policyDocumentType",
      "policyIssueDate",
      "policyNumber",
      "policyRemark",
      "policyReplacement",
      "premiumFinancing",
      "product",
      "productCategory",
      "productType",
      "professionalInvestor",
      "provider",
      "receivedDate",
      "reinstateDate",
      "remark",
      "renewalCount",
      "renewalStatus",
      "signedBy",
      "signedBy2",
      "signedDate",
      "signedPlace",
      "status",
      "submissionDate",
      "taxable",
      "totalWithdrawalAmount",
      "transferInEffectiveDate",
      "transferOutDate",
      "type",
      "lineOfBusiness",
      "requiresCdd",
      "eddRequired",
      "complianceReviewRequired",
      "pendingCasesCreated",
      "pendingCasesRemoved",
      "pendingCasesDone",
      "pendingCasesUndo",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: DATA_ORDER_STATUS },
      { field: "renewalStatus", label: "Renewal Status", options: RENEWAL_STATUS_OPTIONS },
    ],
  },
  {
    value: "debitNote",
    label: "Debit Note",
    watchFields: [
      "client",
      "clientFixRate",
      "clientType",
      "code",
      "commissionRate",
      "confirmedAt",
      "consultants",
      "costTotal",
      "createdBy",
      "currency",
      "date",
      "discountAmount",
      "forceRenewal",
      "holdCover.date",
      "holdCover.remark",
      "insuredValue",
      "mortgageeHirePurchaseName",
      "mortgageePostalAddress",
      "mortgagePostDate",
      "order",
      "parentCompany",
      "payment.amount",
      "payment.adjustmentAmount",
      "payment.totalByCredit",
      "paymentStatus",
      "agingStatus",
      "period.end",
      "period.start",
      "policyDispatchedAt",
      "policyNumber",
      "policyReceivedAt",
      "policyStatus",
      "product",
      "productType",
      "profit",
      "provider",
      "providerCostReference",
      "providerFixRate",
      "refNo",
      "remark",
      "renewalCount",
      "renewalStatus",
      "settledAt",
      "settlement.amount",
      "settlement.paymentMethod",
      "settlement.remark",
      "settlement.settleDate",
      "signedBy",
      "signedBy2",
      "status",
      "taxable",
      "to",
      "total",
      "type",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: DATA_DN_STATUS },
      { field: "paymentStatus", label: "Payment Status", options: DATA_DN_PAYMENT_STATUS },
      { field: "agingStatus", label: "Aging Status", options: DATA_DN_AGING_STATUS },
      { field: "policyStatus", label: "Policy Status", options: POLICY_STATUS_OPTIONS },
      { field: "renewalStatus", label: "Renewal Status", options: RENEWAL_STATUS_OPTIONS },
    ],
  },
  {
    value: "clientPayment",
    label: "Client Payment",
    watchFields: ["directToProvider", "amount", "status", "singleProvider"],
    setValueFields: [
      {
        field: "status",
        label: "Status",
        options: [
          { value: "MATCHING", label: "Matching" },
          { value: "MATCHED", label: "Matched" },
          { value: "DIRECT", label: "Direct to Provider" },
          { value: "PENDING_APPROVAL", label: "Pending approval" },
          { value: "VOID", label: "Void" },
          { value: "REFUND", label: "Refund" },
        ],
      },
    ],
  },
  {
    value: "quotation",
    label: "Quotation",
    watchFields: [
      "client",
      "code",
      "consultants",
      "currency",
      "product",
      "provider",
      "status",
      "total",
    ],
    setValueFields: [
      {
        field: "status",
        label: "Status",
        options: [
          { value: "DFT", label: "Draft" },
          { value: "WAIT", label: "Wait" },
          { value: "CONFIRM", label: "Confirmed" },
          { value: "CAN", label: "Cancelled" },
        ],
      },
    ],
  },
  {
    value: "user",
    label: "User",
    watchFields: [
      "address",
      "aliasName",
      "birthday",
      "cname",
      "contacts",
      "consultantInfo.iaApplyDate",
      "consultantInfo.iaEffectiveDate",
      "consultantInfo.iaFirstRegisterDate",
      "consultantInfo.iaNumber",
      "consultantInfo.iaRole",
      "consultantInfo.iaTerminationDate",
      "consultantInfo.mpfaApplyDate",
      "consultantInfo.mpfaEffectiveDate",
      "consultantInfo.mpfaFirstRegisterDate",
      "consultantInfo.mpfaNumber",
      "consultantInfo.mpfaRole",
      "consultantInfo.mpfaTerminationDate",
      "consultantInfo.overridingPlan",
      "consultantInfo.paymentMethods.accNumber",
      "consultantInfo.paymentMethods.files",
      "consultantInfo.paymentMethods.otherAccounts",
      "consultantInfo.paymentMethods.bank",
      "consultantInfo.paymentMethods.name",
      "consultantInfo.paymentMethods.type",
      "consultantInfo.sfcApplyDate",
      "consultantInfo.sfcEffectiveDate",
      "consultantInfo.sfcFirstRegisterDate",
      "consultantInfo.sfcNumber",
      "consultantInfo.sfcRole",
      "department",
      "departmentId",
      "disableCreateOrder",
      "disposalStatus",
      "educationLevel",
      "email",
      "emails",
      "addresses",
      "emergencyContact",
      "emergencyContactNo",
      "employmentDate",
      "gender",
      "givenName",
      "hkid",
      "idIssueCountry",
      "idType",
      "isActive",
      "isConsultant",
      "mariage",
      "name",
      "nationality",
      "parent",
      "personalEmail",
      "phone",
      "phones",
      "phone2",
      "providerLogin",
      "referedBy",
      "staffId",
      "status",
      "surname",
      "teams",
      "termination.effectiveDate",
      "termination.lastEmploymentDate",
      "termination.reason",
      "termination.resignDate",
      "userCategory",
      "userRole",
      "userType",
      "wallet",
      "workTitle",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: USER_STATUS_OPTIONS },
      {
        field: "disposalStatus",
        label: "Disposal Status",
        options: DATA_USER_DISPOSAL_STATUS,
      },
    ],
  },
  {
    value: "quiz",
    label: "Quiz",
    watchFields: [
      "body",
      "code",
      "createdBy",
      "deadline",
      "maxRetakeCount",
      "noLicenceNeed",
      "passingRate",
      "requiredLicenses",
      "requiredSfcLicences",
      "startDate",
      "status",
      "targetRole",
      "testDuration",
      "title",
    ],
    setValueFields: [{ field: "status", label: "Status", options: QUIZ_STATUS_OPTIONS }],
  },
  {
    value: "product",
    label: "Product",
    watchFields: [
      "activeTable",
      "ageType",
      "allowOffShore",
      "allowPreimumFinancing",
      "allowPrepaid",
      "category",
      "cname",
      "code",
      "currency",
      "description",
      "inactiveSince",
      "insuredWeeklyAge",
      "isActive",
      "jurisdiction",
      "minInitialCharge",
      "minInsured",
      "minPremium",
      "name",
      "otherName",
      "payModes",
      "payTermMax",
      "payTermMin",
      "planCode",
      "policyPledege",
      "popularity",
      "provider",
      "scname",
      "status",
      "type",
    ],
    setValueFields: [{ field: "status", label: "Status", options: DATA_PRODUCT_STATUS }],
  },
  {
    value: "provider",
    label: "Provider",
    watchFields: [
      "address",
      "ageType",
      "cname",
      "code",
      "email",
      "fax",
      "insurerCode",
      "isActive",
      "name",
      "paymentInfo",
      "productCategories",
      "remark",
      "shortName",
      "tel",
      "website",
    ],
    setValueFields: [],
  },
  {
    value: "productType",
    label: "Product Type",
    watchFields: [
      "allowQuoRequest",
      "category",
      "cname",
      "code",
      "groupCode",
      "groupName",
      "investmentTransactions",
      "mortgageeHirePurchase",
      "levySettings.ecLevy.formulaType",
      "levySettings.ecLevy.required",
      "levySettings.iaLevy.required",
      "levySettings.mibLevy.required",
      "name",
      "renewable",
    ],
    setValueFields: [],
  },
  {
    value: "cpd",
    label: "CPD Record",
    watchFields: ["passApproval", "courseTitle", "courseCode", "consultant"],
    setValueFields: [{ field: "passApproval", label: "Approved" }],
  },
  {
    value: "orderInvestmentTransaction",
    label: "Investment Transaction",
    watchFields: [
      "orderId",
      "status",
      "ifastTransactionNo",
      "complianceReviewRequired",
      "handlerBy",
    ],
    setValueFields: [
      {
        field: "status",
        label: "Status",
        options: INVESTMENT_TRANSACTION_STATUS_OPTIONS,
      },
    ],
  },
  {
    value: "commissionSchedule",
    label: "Commission Schedule",
    watchFields: ["effectiveDate", "endDate", "status", "remark"],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "commissionRelease",
    label: "Commission Release",
    watchFields: ["payroll", "consultant", "totalAmount", "bidIds"],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "clientTransfer",
    label: "Client Transfer",
    watchFields: [
      "fromConsultant",
      "toConsultant",
      "clientIds",
      "transferBidOwnership",
    ],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "productDueDiligence",
    label: "Product Due Diligence",
    watchFields: ["product", "reviewType", "dueDate", "status"],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "personalTradingDeclaration",
    label: "Personal Trading Declaration",
    watchFields: ["consultant", "declarationDate", "status", "files"],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "personalTradingAccount",
    label: "Personal Trading Account",
    watchFields: [
      "consultant",
      "brokerName",
      "accountNumber",
      "accountType",
      "accountStatus",
      "productTypes",
    ],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "expenseClaim",
    label: "Expense Claim",
    watchFields: [
      "expenseType",
      "amountHkd",
      "amountPerAttendee",
      "currency",
      "total",
      "merchant",
      "status",
    ],
    setValueFields: [
      {
        field: "status",
        label: "Status",
        options: [
          { value: "DFT", label: "Draft" },
          { value: "APPROVED", label: "Approved" },
        ],
      },
    ],
  },
  {
    value: "orderService",
    label: "Order Service",
    watchFields: [
      "serviceType",
      "serviceTypeSnapShot.code",
      "serviceTypeCode",
      "status",
      "orderId",
      "description",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: DATA_ORDER_SERVICE_STATUS },
    ],
  },
  {
    value: "approval",
    label: "Approval",
    apiEntity: "mcaProcess",
    watchFields: [
      "name",
      "cname",
      "description",
      "status",
      "priority",
      "triggerType",
      "triggerConfig.targetEntity",
      "triggerConfig.action",
      "triggerConfig.watchFields",
      "triggerConfig.allowedMakers",
      "triggerConfig.allowedMakerRoles",
      "steps",
    ],
    setValueFields: [
      {
        field: "status",
        label: "Status",
        options: [
          { value: "DFT", label: "Draft" },
          { value: "ACTIVE", label: "Active" },
          { value: "INACTIVE", label: "Inactive" },
        ],
      },
    ],
  },
];

export const MCA_WATCH_FIELD_LOGIC = [
  { value: "OR", label: "Any condition matches (OR)" },
  { value: "AND", label: "All conditions must match (AND)" },
];

export const MCA_ACTIONS = [
  { value: "CREATE", label: "Create" },
  { value: "UPDATE", label: "Update" },
  { value: "DELETE", label: "Delete" },
];

export const MCA_TRIGGER_TYPES = [
  { value: "HOOK", label: "Automatic (Hook)" },
  { value: "MANUAL", label: "Manual" },
];

export const MCA_APPROVAL_TYPES = [
  { value: "ANY", label: "Any one approver" },
  { value: "ALL", label: "All approvers must approve" },
];

export const MCA_ROUTING_ACTION_TYPES = [
  { value: "GO_TO_STEP", label: "Go to step" },
  { value: "FINISH", label: "Direct Approve" },
];

export const MCA_BUTTON_COLORS = [
  { value: "blue", label: "Blue" },
  { value: "teal", label: "Teal" },
  { value: "green", label: "Green" },
  { value: "cyan", label: "Cyan" },
  { value: "indigo", label: "Indigo" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "red", label: "Red" },
  { value: "pink", label: "Pink" },
  { value: "dark", label: "Black" },
];

export const DEFAULT_ROUTING_ACTION_COLOR = {
  GO_TO_STEP: "blue",
  FINISH: "teal",
};

export const defaultRoutingAction = (type = "GO_TO_STEP") => ({
  type,
  label: "",
  cname: "",
  color: DEFAULT_ROUTING_ACTION_COLOR[type] ?? "blue",
  targetStepOrder: null,
});

export const CONDITION_TYPES = [
  { value: "$eq", label: "Equals" },
  { value: "$in", label: "In list" },
  { value: "$gt", label: "Greater than" },
  { value: "$gte", label: "Greater or equal" },
  { value: "$lt", label: "Less than" },
  { value: "$lte", label: "Less or equal" },
];

export const getEntityLabel = (value) =>
  MCA_ENTITIES.find((e) => e.value === value)?.label ?? value;

export const getEntitySetValueFields = (entityValue) =>
  MCA_ENTITIES.find((e) => e.value === entityValue)?.setValueFields ?? [];

export const MCA_RELATED_SET_VALUE_TARGETS = {
  orderInvestmentTransaction: [
    {
      entity: "client",
      label: "Client",
      fields: [
        {
          field: "currentAssets",
          label: "Current Assets Amount",
          valueFrom: "arForm.declaredNetWealth",
          valueLabel: "Declared net wealth (excl. property) HKD",
        },
      ],
    },
  ],
};

export const getRelatedSetValueTargets = (entityValue) =>
  MCA_RELATED_SET_VALUE_TARGETS[entityValue] ?? [];

export const MCA_NOTIFY_BY = [
  { value: "EMAILS", label: "Emails" },
  { value: "USERS", label: "Users" },
  { value: "USER_ROLE", label: "User Role" },
  { value: "ENTITY_ROLE", label: "Entity Role" },
  { value: "NEXT_APPROVERS", label: "Next step approvers" },
];

export const MCA_SEND_TIMING = [
  { value: "START", label: "Start of the step" },
  { value: "COMPLETE", label: "Completion of the step" },
  { value: "APPROVED", label: "Approval fully completed" },
];

const CLIENT_LINK_ENTITIES = new Set([
  "client",
  "order",
  "debitNote",
  "quotation",
  "orderInvestmentTransaction",
  "clientPayment",
]);

const PROVIDER_LINK_ENTITIES = new Set([
  "order",
  "debitNote",
  "quotation",
  "renewal",
  "clientPayment",
]);

const ENTITY_ROLE_LABELS = {
  maker: "Maker",
  user: "User",
  client: "Client",
  consultants: "Consultants",
  insurer: "Insurer",
};

export const entityRoleOptions = (targetEntity) => {
  const options = [{ value: "maker", label: "Maker" }];
  if (targetEntity === "user") options.push({ value: "user", label: "User" });
  if (CLIENT_LINK_ENTITIES.has(targetEntity)) {
    options.push(
      { value: "client", label: "Client" },
      { value: "consultants", label: "Consultants" }
    );
  }
  if (PROVIDER_LINK_ENTITIES.has(targetEntity)) {
    options.push({ value: "insurer", label: "Insurer" });
  }
  return options;
};

const USER_ENTITY_ROLES = new Set(["maker", "user", "consultants"]);

export const MCA_USER_VALUE_SOURCES = [
  { value: "USER", label: "Specific User" },
  { value: "ENTITY_ROLE", label: "Entity Role" },
  { value: "APPROVAL_ROLE", label: "Approval Role" },
];

export const userEntityRoleOptions = (targetEntity) =>
  entityRoleOptions(targetEntity).filter((option) => USER_ENTITY_ROLES.has(option.value));

const sortedApprovalSteps = (steps = []) =>
  [...(steps ?? [])].sort(
    (a, b) => (Number(a?.order) || 0) - (Number(b?.order) || 0)
  );

export const approvalRoleLabel = (value, steps = []) => {
  if (value === "REQUESTER") return "Requester";
  if (value === "FINAL") return "Final Approver";
  const match = /^STEP:(\d+)$/.exec(String(value ?? ""));
  if (!match) return value ? String(value) : "";
  const order = Number(match[1]);
  const sorted = sortedApprovalSteps(steps);
  const index = sorted.findIndex(
    (step, idx) => Number(step?.order ?? idx + 1) === order
  );
  return `Step ${index >= 0 ? index + 1 : order} Approver`;
};

export const approvalRoleOptions = (steps = []) => {
  const sorted = sortedApprovalSteps(steps);
  const options = [{ value: "REQUESTER", label: "Requester" }];
  if (!sorted.length) {
    options.push({ value: "FINAL", label: "Final Approver" });
    return options;
  }
  sorted.forEach((step, index) => {
    const isLast = index === sorted.length - 1;
    if (isLast) {
      options.push({ value: "FINAL", label: "Final Approver" });
      return;
    }
    const order = step?.order ?? index + 1;
    options.push({
      value: `STEP:${order}`,
      label: `Step ${index + 1} Approver`,
    });
  });
  return options;
};

export const entityRoleFromNotification = (notification) => {
  if (!notification) return "";
  if (notification.notifyEntityProvider) return "insurer";
  if (notification.notifyEntityConsultants) return "consultants";
  if (notification.notifyEntityClient) return "client";
  if (notification.notifyEntityUser) return "user";
  if (notification.notifyMaker) return "maker";
  return "";
};

const hasPrimaryNotifyList = (notification, notifyBy) => {
  if (notifyBy === "EMAILS") return (notification.notifyEmails ?? []).length > 0;
  if (notifyBy === "USERS") return (notification.notifyUsers ?? []).length > 0;
  if (notifyBy === "USER_ROLE") return (notification.notifyRoles ?? []).length > 0;
  return false;
};

export const notificationRecipientMode = (notification) => {
  const notifyBy = notification?.notifyBy ?? "USERS";
  if (notifyBy === "ENTITY_ROLE" || notifyBy === "NEXT_APPROVERS") return notifyBy;
  const primary = hasPrimaryNotifyList(notification, notifyBy);
  if (!primary && entityRoleFromNotification(notification)) return "ENTITY_ROLE";
  if (!primary && notification?.notifyNextApprovers) return "NEXT_APPROVERS";
  return notifyBy;
};

export const sendTimingFromNotification = (notification) => {
  const selected = [];
  if (notification?.notifyOnStart) selected.push("START");
  if (notification?.notifyOnComplete !== false) selected.push("COMPLETE");
  if (notification?.notifyOnApproved) selected.push("APPROVED");
  return selected.join(",");
};

export const sendTimingSelectData = (notification) => {
  const value = sendTimingFromNotification(notification);
  if (!value || MCA_SEND_TIMING.some((option) => option.value === value)) {
    return MCA_SEND_TIMING;
  }
  const label = value
    .split(",")
    .map((code) => MCA_SEND_TIMING.find((option) => option.value === code)?.label ?? code)
    .join(", ");
  return [...MCA_SEND_TIMING, { value, label }];
};

export const APPROVED_SEND_TIMING_NOTE =
  "New entity data will be applied on the notification";

export const sendTimingFlags = (timing) => ({
  notifyOnStart: timing === "START",
  notifyOnComplete: timing === "COMPLETE",
  notifyOnApproved: timing === "APPROVED",
});

export const MCA_NOTIFY_CHANNELS = [
  { value: "EMAIL", label: "Email" },
  { value: "SMS", label: "SMS" },
];

export const MCA_NOTIFICATION_TEMPLATE_VARS = [
  { value: "requestCode", label: "Request code", token: "{{requestCode}}" },
  { value: "stepName", label: "Step name", token: "{{stepName}}" },
  { value: "entityCode", label: "Entity code", token: "{{entityCode}}" },
  { value: "actorName", label: "Actor name", token: "{{actorName}}" },
  { value: "trigger", label: "Trigger (START / COMPLETE)", token: "{{trigger}}" },
];

const USER_PASSWORD_TEMPLATE_VAR = {
  value: "userPassword",
  label: "User password",
  token: "{{userPassword}}",
  group: "This step",
};

const ADDRESS_TEMPLATE_PARTS = [
  ["line1", "line 1"],
  ["line2", "line 2"],
  ["city", "city"],
  ["state", "state"],
  ["zipCode", "zip code"],
  ["country", "country"],
];

const addressTemplateFields = (prefix, scope) =>
  ADDRESS_TEMPLATE_PARTS.map(([part, partLabel]) => ({
    value: `${prefix}.${part}`,
    label: `${scope} ${partLabel}`,
  }));

export const CLIENT_ADDRESS_TEMPLATE_FIELDS = [
  ...addressTemplateFields("entity.address", "Default address"),
  ...addressTemplateFields("entity.address.residential", "Residential address"),
  ...addressTemplateFields("entity.address.correspondence", "Correspondence address"),
];

const RELATED_TEMPLATE_VARS = {
  client: ["entityUrl", "now", ...CLIENT_ADDRESS_TEMPLATE_FIELDS.map((field) => field.value)],
  order: ["client.name", "product.name", "provider.name", "consultant.name", "entityUrl", "now"],
  debitNote: [
    "client.name",
    "client.email",
    "product.name",
    "provider.name",
    "provider.email",
    "consultant.name",
    "consultant.staffId",
    "entityUrl",
    "now",
  ],
  quotation: ["client.name", "product.name", "consultant.name", "entityUrl", "now"],
};

const RELATED_LABELS = {
  entityUrl: "Record link",
  now: "Current date/time",
  ...Object.fromEntries(
    CLIENT_ADDRESS_TEMPLATE_FIELDS.map((field) => [field.value, field.label])
  ),
};

const humanizeField = (field) =>
  String(field)
    .split(".")
    .map((part) =>
      part
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/^./, (char) => char.toUpperCase())
    )
    .join(" ");

const CLIENT_PAYMENT_DEBIT_NOTE_FIELDS = [
  ["client.name", "Client name"],
  ["client.email", "Client email"],
  ["product.name", "Product name"],
  ["provider.name", "Insurer name"],
  ["provider.email", "Insurer email"],
  ["consultant.name", "Consultant name"],
  ["consultant.staffId", "Consultant staff ID"],
];

const templateVar = (value, group, label) => ({
  value,
  label: label || RELATED_LABELS[value] || humanizeField(value.replace(/^entity\./, "")),
  token: `{{${value}}}`,
  group,
});

export const getMcaNotificationTemplateVars = (targetEntity) => {
  const step = MCA_NOTIFICATION_TEMPLATE_VARS.map((item) => ({
    ...item,
    group: "This step",
  }));
  if (targetEntity === "user") step.push(USER_PASSWORD_TEMPLATE_VAR);

  const entity = MCA_ENTITIES.find((item) => item.value === targetEntity);
  if (!entity) return step;

  const seen = new Set(step.map((item) => item.value));
  const fields = [];
  (entity.watchFields || []).forEach((field) => {
    const value = `entity.${field}`;
    if (seen.has(value)) return;
    seen.add(value);
    fields.push(templateVar(value, entity.label, humanizeField(field)));
  });
  (RELATED_TEMPLATE_VARS[targetEntity] || []).forEach((value) => {
    if (seen.has(value)) return;
    seen.add(value);
    fields.push(templateVar(value, entity.label));
  });

  if (targetEntity === "clientPayment") {
    const debitNote = MCA_ENTITIES.find((item) => item.value === "debitNote");
    const group = debitNote?.label || "Debit Note";
    (debitNote?.watchFields || []).forEach((field) => {
      const value = `debitNote.${field}`;
      if (seen.has(value)) return;
      seen.add(value);
      fields.push(templateVar(value, group, humanizeField(field)));
    });
    CLIENT_PAYMENT_DEBIT_NOTE_FIELDS.forEach(([field, label]) => {
      const value = `debitNote.${field}`;
      if (seen.has(value)) return;
      seen.add(value);
      fields.push(templateVar(value, group, label));
    });
  }

  return [...step, ...fields];
};

export const defaultStepNotification = () => ({
  name: "",
  channel: "EMAIL",
  notifyOnStart: false,
  notifyOnComplete: true,
  notifyOnApproved: false,
  notifyBy: "USERS",
  notifyEmails: [],
  notifyUsers: [],
  notifyRoles: [],
  notifyMaker: false,
  notifyNextApprovers: false,
  notifyEntityUser: false,
  notifyEntityClient: false,
  notifyEntityConsultants: false,
  notifyEntityProvider: false,
  notifyEntityProviderPurpose: "",
  subject: "",
  message: "",
  cc: "",
  bcc: "",
  attachmentKeys: [],
  encrypt: false,
  passwordSubject: "",
  passwordBody: "",
  conditionLogic: "OR",
  conditions: [],
});

export const validateStepNotification = (notification) => {
  if (!notification.name?.trim()) {
    return "Name is required";
  }
  if (
    !notification.notifyOnStart &&
    notification.notifyOnComplete === false &&
    !notification.notifyOnApproved
  ) {
    return "Select when to send";
  }
  const by = notificationRecipientMode(notification);
  const hasPrimary =
    (by === "EMAILS" && (notification.notifyEmails ?? []).length > 0) ||
    (by === "USERS" && (notification.notifyUsers ?? []).length > 0) ||
    (by === "USER_ROLE" && (notification.notifyRoles ?? []).length > 0) ||
    (by === "ENTITY_ROLE" && !!entityRoleFromNotification(notification)) ||
    (by === "NEXT_APPROVERS" && !!notification.notifyNextApprovers);
  if (by === "ENTITY_ROLE" && !entityRoleFromNotification(notification)) {
    return "Select an entity role";
  }
  const hasAdditional =
    notification.notifyMaker ||
    notification.notifyNextApprovers ||
    notification.notifyEntityUser ||
    notification.notifyEntityClient ||
    notification.notifyEntityConsultants ||
    notification.notifyEntityProvider;
  if (!hasPrimary && !hasAdditional) {
    return "Select at least one recipient";
  }
  if (
    notification.notifyEntityProvider &&
    !String(notification.notifyEntityProviderPurpose || "").trim()
  ) {
    return "Select an insurer email purpose";
  }
  if ((notification.channel ?? "EMAIL") === "EMAIL") {
    if (!notification.subject?.trim()) {
      return "Email subject is required";
    }
    if (!notification.message?.trim()) {
      return "Email message is required";
    }
  }
  if (notification.channel === "SMS" && !notification.message?.trim()) {
    return "SMS message is required";
  }
  const incompleteCondition = (notification.conditions ?? []).some((row) => {
    const field = String(row?.field ?? "").trim();
    if (!field) return false;
    if (row.condition && typeof row.condition === "object") return false;
    const hasOperator = !!row.conditionType;
    const hasValue = row.conditionValue !== "" && row.conditionValue != null;
    return !hasOperator || !hasValue;
  });
  if (incompleteCondition) {
    return "Each send condition needs a field, operator, and value";
  }
  return null;
};

const notifyByLabel = (value) =>
  MCA_NOTIFY_BY.find((o) => o.value === value)?.label ?? value;

export const summarizeNotificationRecipients = (notification) => {
  if (!notification) return "—";
  const parts = [];
  const by = notificationRecipientMode(notification);
  if (by === "NEXT_APPROVERS") {
    parts.push("Next step approvers");
  } else if (by === "ENTITY_ROLE") {
    const selected = [
      notification.notifyMaker && ENTITY_ROLE_LABELS.maker,
      notification.notifyEntityUser && ENTITY_ROLE_LABELS.user,
      notification.notifyEntityClient && ENTITY_ROLE_LABELS.client,
      notification.notifyEntityConsultants && ENTITY_ROLE_LABELS.consultants,
      notification.notifyEntityProvider && ENTITY_ROLE_LABELS.insurer,
    ].filter(Boolean);
    parts.push(selected.join(", ") || "Entity Role");
  } else if (by === "EMAILS") {
    const count = (notification.notifyEmails ?? []).length;
    parts.push(count ? `${count} email${count > 1 ? "s" : ""}` : "Emails");
  } else if (by === "USERS") {
    const count = (notification.notifyUsers ?? []).length;
    parts.push(count ? `${count} user${count > 1 ? "s" : ""}` : "Users");
  } else if (by === "USER_ROLE") {
    const count = (notification.notifyRoles ?? []).length;
    parts.push(count ? `${count} role${count > 1 ? "s" : ""}` : "User Role");
  }
  if (by !== "ENTITY_ROLE" && by !== "NEXT_APPROVERS") {
    if (notification.notifyMaker) parts.push("Maker");
    if (notification.notifyEntityUser) parts.push("Entity user");
    if (notification.notifyEntityClient) parts.push("Entity client");
    if (notification.notifyEntityConsultants) parts.push("Entity consultants");
    if (notification.notifyEntityProvider) parts.push("Entity insurer");
  }
  if (by !== "NEXT_APPROVERS" && notification.notifyNextApprovers) {
    parts.push("Next step approvers");
  }
  return parts.length ? parts.join(", ") : notifyByLabel(by);
};

export const summarizeNotificationWhen = (notification) => {
  const parts = [];
  if (notification?.notifyOnStart) parts.push("Start");
  if (notification?.notifyOnComplete !== false) parts.push("Complete");
  if (notification?.notifyOnApproved) parts.push("Approval fully completed");
  const when = parts.length ? parts.join(", ") : "—";
  const count = (notification?.conditions ?? []).filter((row) =>
    String(row?.field ?? "").trim()
  ).length;
  const suffix = count
    ? `${count} condition${count > 1 ? "s" : ""}`
    : "always";
  return `${when} · ${suffix}`;
};

export const MCA_STEP_FIELD_TYPES = [
  { value: "TEXT", label: "Text" },
  { value: "TEXTAREA", label: "Textarea" },
  { value: "INTEGER", label: "Integer" },
  { value: "DECIMAL_2", label: "Decimal (2)" },
  { value: "DECIMAL_4", label: "Decimal (4)" },
  { value: "DATE", label: "Date" },
  { value: "DATETIME", label: "Date & time" },
  { value: "SINGLE_FILE", label: "Single file" },
  { value: "MULTIPLE_FILES", label: "Multiple files" },
];

export const isFileFieldType = (inputType) =>
  inputType === "SINGLE_FILE" ||
  inputType === "MULTIPLE_FILES" ||
  inputType === "FILE";

export const isNumberFieldType = (inputType) =>
  inputType === "NUMBER" ||
  inputType === "INTEGER" ||
  inputType === "DECIMAL_2" ||
  inputType === "DECIMAL_4";

export const normalizeStepFieldInputType = (field) => {
  const inputType = field?.inputType ?? "TEXT";
  if (inputType === "FILE") {
    return field?.multiple ? "MULTIPLE_FILES" : "SINGLE_FILE";
  }
  if (inputType === "NUMBER") return "INTEGER";
  return inputType;
};

export const normalizeStepField = (field) => ({
  label: field.label ?? "",
  cname: field.cname ?? "",
  inputType: normalizeStepFieldInputType(field),
  required: !!field.required,
});

export const getStepFieldNumberPrecision = (field) => {
  const inputType = field?.inputType ?? "TEXT";
  if (inputType === "DECIMAL_2") return 2;
  if (inputType === "DECIMAL_4") return 4;
  return 0;
};

export const formatStaffLabel = (user) => {
  if (!user) return null;
  if (typeof user !== "object") return String(user);
  const staffId = user.staffId ?? "--";
  const name = user.name?.trim() ?? "";
  const cname = user.cname?.trim() ?? "";
  const aliasName = user.aliasName?.trim() ?? "";
  const nameParts = [];
  if (name) nameParts.push(name);
  if (cname && cname !== name) nameParts.push(cname);
  const namePart = nameParts.join(", ");
  const suffix =
    aliasName && aliasName !== name && aliasName !== cname
      ? namePart
        ? ` ${aliasName}`
        : aliasName
      : "";
  if (!namePart && !suffix) return `[${staffId}]`;
  return `[${staffId}] ${namePart}${suffix}`.trim();
};

export const formatStepFieldNumberValue = (value, precision = 0) => {
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: precision,
  });
};

export const formatStepFieldLabel = (field) => {
  if (!field) return "";
  const en = field.label ?? "";
  const zh = field.cname?.trim();
  if (en && zh) return `${en} / ${zh}`;
  return en || zh || "";
};

export const formatStepFieldValue = (field) => {
  const value = field?.value;
  if (isFileFieldType(field?.inputType)) {
    const files = Array.isArray(value) ? value : [];
    if (!files.length) return "—";
    return files.map((f) => f.fileName).filter(Boolean).join(", ");
  }
  if (value === null || value === undefined || value === "") return "—";
  if (isNumberFieldType(field?.inputType)) {
    return formatStepFieldNumberValue(value, getStepFieldNumberPrecision(field));
  }
  if (field.inputType === "DATE" || field.inputType === "DATETIME") {
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) {
      return field.inputType === "DATETIME"
        ? d.toLocaleString()
        : d.toLocaleDateString();
    }
  }
  return String(value);
};

export const migrateStepFields = (step) => {
  let fields = [];
  if ((step?.stepFields ?? []).length > 0) {
    fields = step.stepFields.map(normalizeStepField);
  } else if (step?.requireComment) {
    fields = [
      {
        label: "Comment",
        cname: "備註",
        inputType: "TEXTAREA",
        required: true,
      },
    ];
  }
  for (const doc of step?.uploadDocuments ?? []) {
    const title = doc.title?.trim();
    if (!title) continue;
    fields.push({
      label: title,
      cname: "",
      inputType: "MULTIPLE_FILES",
      required: !!doc.required,
    });
  }
  return fields;
};

export const migrateStepNotifications = (step) => {
  if ((step?.notifications ?? []).length > 0) {
    return step.notifications.map((n) => ({
      ...defaultStepNotification(),
      ...n,
    }));
  }
  const legacy = step?.notification;
  if (!legacy) return [];
  const hasConfig =
    legacy.enabled ||
    legacy.notifyMaker ||
    legacy.notifyNextApprovers ||
    (legacy.notifyUsers ?? []).length > 0 ||
    (legacy.notifyRoles ?? []).length > 0 ||
    legacy.notifyOnStart ||
    legacy.subject ||
    legacy.message;
  if (!hasConfig) return [];

  let notifyBy = "USERS";
  if ((legacy.notifyRoles ?? []).length && !(legacy.notifyUsers ?? []).length) {
    notifyBy = "USER_ROLE";
  }

  return [
    {
      ...defaultStepNotification(),
      name: "Notification 1",
      channel: "EMAIL",
      notifyOnStart: !!legacy.notifyOnStart,
      notifyOnComplete: legacy.notifyOnComplete !== false,
      notifyOnApproved: false,
      notifyBy,
      notifyEmails: [],
      notifyUsers: legacy.notifyUsers ?? [],
      notifyRoles: legacy.notifyRoles ?? [],
      notifyMaker: !!legacy.notifyMaker,
      notifyNextApprovers: !!legacy.notifyNextApprovers,
      notifyEntityUser: false,
      notifyEntityClient: false,
      notifyEntityConsultants: false,
      notifyEntityProvider: false,
      notifyEntityProviderPurpose: "",
      subject: legacy.subject ?? "",
      message: legacy.message ?? "",
    },
  ];
};
